/**
 * PermissaoTemplate — catálogo global de permissões (controller+action), somente leitura.
 *
 * Gerenciado só por `Grupo.sincronizarPermissoes` (ver GrupoTemplate) — sem create/update/
 * destroy no backend (`PermissaoController` estende `BaseLeituraController`).
 */
import React, { Component } from 'react';

import { EntityGrid } from 'hay-core-react';
import Permissao from '../../../models/Permissao';

const model = {
  controller: { exibir: 'main.permissao.controller', visivel: true },
  action: { exibir: 'main.permissao.action', visivel: true },
  tipo: { exibir: 'main.permissao.tipo', visivel: true },
  state: { exibir: 'main.permissao.state', visivel: true },
};

class PermissaoTemplate extends Component {
  render() {
    return (
      <EntityGrid
        entidade={Permissao}
        model={model}
        identidade="main.permissao"
        permissoes={this.props.permissoes}
        icone="pi-key"
        storageKey="dt-permissoes"
        processos={[]}
        ocultarColunaPublicacao={true}
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={() => null}
      />
    );
  }
}

export default PermissaoTemplate;
